import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import helper from '@/utils/helper';
import App from './App.vue';
import store from './store';
import router from './router';

Vue.config.productionTip = false;

Vue.mixin(helper);

Vue.filter('truncate', (text, length, suffix) => {
  if (text.length > length) {
    return text.substring(0, length) + suffix;
  }
  return text;
});

if (process.env.SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [new VueIntegration({ Vue, attachProps: true })],
  });
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
